<template>
  <b-container fluid>
    <b-table
      :items="plantoes"
      :fields="campos_tabela"
      selectable
      select-mode="multi"
      @row-selected="rowSelected"
    >
      <template v-slot:cell(situacao)="row">
        <!-- `data.value` is the value after formatted by the Formatter -->
        <b-row align-h="end" class="mr-1">
          <b-badge v-if="row.item.criado_em == null" size="sm" variant="danger"
            >Não confirmada</b-badge
          >
          <b-badge v-else size="sm" variant="success">Confirmada</b-badge>
        </b-row>
      </template>
    </b-table>
    <b-button
      variant="success"
      size="sm"
      class="mr-2"
      :disabled="!botoesAtivados"
      @click="confirmaRefeicao"
      >Confirmar</b-button
    >
    <b-button
      variant="danger"
      size="sm"
      :disabled="!botoesAtivados"
      @click="cancelaRefeicao"
      >Cancelar</b-button
    >
  </b-container>
</template>

<script>
import mixinToast from "@/mixins/mixinToast.js";

export default {
  props: ["item"],
  mixins: [mixinToast],
  computed: {
    botoesAtivados() {
      return this.plantoes_selecionados.length > 0 && this.isProcessing == false;
    },
  },
  data() {
    return {
      plantoes: null,
      plantoes_selecionados: [],
      isProcessing: false,
      campos_tabela: [
        { key: "descricao", label: "Refeição" },
        { key: "situacao", label: "Situação", thClass: "cabecalho-direita" },
      ],
    };
  },
  methods: {
    rowSelected(items) {
      this.plantoes_selecionados = items;
    },
    confirmaRefeicao() {
      this.item.cpf = this.$store.getters.getLoggedUser.cpf;
      this.isProcessing = true;
      console.log(this.plantoes_selecionados);
      console.log(this.item);
      this.$http
        .post("/confirmarefeicoes", {
          refeicoes: this.plantoes_selecionados,
          dados_escala: this.item,
        })
        .then((result) => {
          result.data.forEach((element) => {
            this.exibeToast(element.success, element.message);
            this.isProcessing = false;
          });
          this.getRefeicoes();
        });
    },
    cancelaRefeicao() {
      this.item.cpf = this.$store.getters.getLoggedUser.cpf;
      this.isProcessing = true;
      this.$http
        .post("/cancelarefeicoes", {
          refeicoes: this.plantoes_selecionados,
          dados_escala: this.item,
        })
        .then((result) => {
          result.data.forEach((element) => {
            this.exibeToast(element.success, element.message);
            this.isProcessing = false;
          });
          this.getRefeicoes();
        });
    },
    getRefeicoes() {
      this.item.cpf = this.$store.getters.getLoggedUser.cpf;
      this.$http
        .get(
          `/refeicoesporplantao?dia=${this.item.dia}&tipo_plantao_id=${this.item.tipo_plantao_id}&mes=${this.item.mes}&cpf=${this.item.cpf}`
        )
        .then((result) => {
          this.plantoes = result.data;
        });
    },
  },
  mounted() {
    console.log(this.item);
    this.getRefeicoes();
  },
};
</script>

<style>
</style>